import { render } from "./confirm-email.html?vue&type=template&id=51cb7efa&scoped=true&external"
import script from "./confirm-email.vue?vue&type=script&lang=js"
export * from "./confirm-email.vue?vue&type=script&lang=js"

import "./confirm-email.vue?vue&type=style&index=0&id=51cb7efa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51cb7efa"]])

export default __exports__